import Icon from "@ant-design/icons";
import React from "react";

export default function ShareIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C12.2126 4 12.4152 4.09024 12.5575 4.24828L14.8075 6.74828C15.0846 7.05616 15.0596 7.53038 14.7517 7.80747C14.4438 8.08457 13.9696 8.05961 13.6925 7.75172L12.75 6.70447V14.25C12.75 14.6642 12.4142 15 12 15C11.5858 15 11.25 14.6642 11.25 14.25V6.70447L10.3075 7.75172C10.0304 8.05961 9.55616 8.08457 9.24828 7.80747C8.94039 7.53038 8.91544 7.05616 9.19253 6.74828L11.4425 4.24828C11.5848 4.09024 11.7874 4 12 4ZM5.80546 10.8055C6.32118 10.2897 7.02065 10 7.75 10H8.25C8.66421 10 9 10.3358 9 10.75C9 11.1642 8.66421 11.5 8.25 11.5H7.75C7.41848 11.5 7.10054 11.6317 6.86612 11.8661C6.6317 12.1005 6.5 12.4185 6.5 12.75V17.25C6.5 17.5815 6.6317 17.8995 6.86612 18.1339C7.10054 18.3683 7.41848 18.5 7.75 18.5H16.25C16.5815 18.5 16.8995 18.3683 17.1339 18.1339C17.3683 17.8995 17.5 17.5815 17.5 17.25V12.75C17.5 12.4185 17.3683 12.1005 17.1339 11.8661C16.8995 11.6317 16.5815 11.5 16.25 11.5H15.75C15.3358 11.5 15 11.1642 15 10.75C15 10.3358 15.3358 10 15.75 10H16.25C16.9793 10 17.6788 10.2897 18.1945 10.8055C18.7103 11.3212 19 12.0207 19 12.75V17.25C19 17.9793 18.7103 18.6788 18.1945 19.1945C17.6788 19.7103 16.9793 20 16.25 20H7.75C7.02065 20 6.32118 19.7103 5.80546 19.1945C5.28973 18.6788 5 17.9793 5 17.25V12.75C5 12.0207 5.28973 11.3212 5.80546 10.8055Z"
        fill="currentColor"
      />
    </svg>
  );
};
